const initialState = {
    position : []
};

const assessmentEvidenceReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'SET_POSITION':
            state.position.push(action.payload)
            return { position: state.position }
        case 'REMOVE_POSITION':
            state.position.pop()
            return { position: state.position }
        case 'CLEAR_POSITION':
            state.position = []
            return { position: state.position }
        default:
            return state;
    }

}

export default assessmentEvidenceReducer;